module.exports = __webpack_public_path__ + "img/red.e975de08.png";